/**
 * Created by chachora on 12/19/18.
 */
import React, { PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import {
  FormTextField,
  FormNumberField,
  InlineNumberField,
  InlineDateTimePicker,
  FormBlock,
  FormSelect,
} from '../Form';
import { positiveInteger, positiveNumber } from '../Form/validators';
import styles from '../EventDialogForm/styles';
import { dateToTimeString } from '../../helpers/dates';
import * as eh from '../../helpers/event-helper';
import { AccordionDetails, Accordion, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  GridTextField,
  Placeholder,
  GridNumberField,
  GridDateTimePicker,
  GridButton,
  TextField,
  GridIconFab,
} from '../Form/shared';
import ServicesProvided from '../EventDialogForm/ServicesProvided';
import Ramp from '../EventDialogForm/Ramp';
import Transfers from '../EventDialogForm/Transfers';
import Offload from '../EventDialogForm/Offload';
import ActualPaxLoad from '../EventDialogForm/ActualPaxLoad';
import Delays from '../EventDialogForm/Delays/Delays';
import PanelSummary from '../PanelSummary';
import withDeletePopup from '../withDeletePopup';
import Tasks from '../EventDialogForm/Tasks/Tasks';
import { withTranslation } from 'react-i18next';

export const initialCargoValue = {
  awbNumber: null,
  packages: null,
  weight: null,
  cmb: null,
};

export const totalTransfers = transfers =>
  transfers.reduce((total, value) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { STA: _, STD: __, ...filteredValue } = value;
    return total + eh.calcObjectTotal(filteredValue);
  }, null);

class EventOutboundForm extends PureComponent {
  // Cargo
  state = {
    expandedCargoItem: null,
  };

  handleAddCargoClick = () => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      `outbound.cargo[${values.outbound.cargo.length}]`,
      initialCargoValue
    );
  };

  handleDeleteCargoClick = index => {
    const { setFieldValue, values } = this.props;
    setFieldValue('outbound.cargo', [
      ...values.outbound.cargo.slice(0, index),
      ...values.outbound.cargo.slice(index + 1),
    ]);
  };

  handleExpandedCargoItem = index => {
    const { expandedCargoItem } = this.state;
    this.setState({
      expandedCargoItem: index === expandedCargoItem ? null : index,
    });
  };

  render() {
    const {
      classes,
      values,
      initialValues,
      rampServices,
      setFieldValue,
      onDeleteConfirmationDialogOpen,
      t,
    } = this.props;
    const { expandedCargoItem } = this.state;
    const { outbound, crewChangeType } = values;
    const { transfers, onwards } = outbound;
    const [isDelayed, dlTimeValue, delay] = eh.calculateDelayTime(
      values.STD,
      outbound.ATD ? outbound.ATD : outbound.ETD
    );

    const delayHours = delay / 3600000;

    let bookedTotalPaxLoad = eh.getTotalPaxLoad(outbound.bookedPaxLoad);
    bookedTotalPaxLoad = bookedTotalPaxLoad ? bookedTotalPaxLoad : '';

    const aircraftSummaryItems = [
      { label: 'Type', value: outbound.aircraftType },
      { label: 'REG', value: outbound.aircraftReg },
      { label: 'Config', value: outbound.aircraftConfig },
      {
        label: 'Crew',
        value: eh.getTotalCrewCount(outbound.crew),
      },
    ];

    const movementSummaryItems = [
      { label: 'ETD', value: dateToTimeString(outbound.ETD) },
      { label: 'ATD', value: dateToTimeString(outbound.ATD) },
      { label: 'DL Time', value: dlTimeValue },
    ];

    const locationsSummaryItems = [
      { label: 'Check-in', value: outbound.checkInCounters },
      { label: 'Gate no.', value: outbound.gateNo },
      { label: 'Parking no.', value: outbound.parkingBay },
    ];

    const actualPaxLoadSummary = eh.getPaxLoadSummary(outbound.actualPaxLoad);
    const actualPaxLoadByClassSummaryItems = [
      { label: 'First', value: actualPaxLoadSummary.first },
      { label: 'Business', value: actualPaxLoadSummary.business },
      { label: 'Economy', value: actualPaxLoadSummary.economy },
    ];

    const actualPaxLoadSummaryItems = [
      { label: 'Adult', value: eh.getTotalAdultsCount(outbound.actualPaxLoad) },
      {
        label: 'Child',
        value: eh.getTotalChildrenCount(outbound.actualPaxLoad),
      },
      { label: 'Infant', value: actualPaxLoadSummary.infant },
      {
        label: 'TOB',
        value: eh.getTotalPaxLoad(actualPaxLoadSummary),
        isHighlighted: true,
      },
    ];

    const totalBaggageSummaryItems = [
      {
        label: 'Baggage PC',
        value: eh.getTotalBagsCount(outbound.actualPaxLoad),
      },
      {
        label: 'Baggage WT',
        value: eh.getTotalBagsWeight(outbound.actualPaxLoad),
      },
    ];

    const transferSummaryItems = [
      {
        label: 'F',
        value: eh.calcArrayPropertyTotal(transfers, 'first'),
      },
      {
        label: 'C',
        value: eh.calcArrayPropertyTotal(transfers, 'business'),
      },
      {
        label: 'Y',
        value: eh.calcArrayPropertyTotal(transfers, 'economy'),
      },
      {
        label: 'INF',
        value: eh.calcArrayPropertyTotal(transfers, 'infant'),
      },
      {
        label: 'Total',
        value: totalTransfers(transfers) || null,
      },
    ];

    const onwardsSummaryItems = [
      {
        label: 'F',
        value: eh.calcArrayPropertyTotal(onwards, 'first'),
      },
      {
        label: 'C',
        value: eh.calcArrayPropertyTotal(onwards, 'business'),
      },
      {
        label: 'Y',
        value: eh.calcArrayPropertyTotal(onwards, 'economy'),
      },
      {
        label: 'INF',
        value: eh.calcArrayPropertyTotal(onwards, 'infant'),
      },
      {
        label: 'Total',
        value: totalTransfers(onwards) || null,
      },
    ];

    const cargoSummaryItems = [
      {
        label: 'AWB No.',
        value: outbound.cargo.length === 0 ? null : outbound.cargo.length,
      },
      {
        label: 'PC',
        value: eh.calcArrayPropertyTotal(outbound.cargo, 'packages'),
      },
      {
        label: 'WT',
        value: eh.calcArrayPropertyTotal(outbound.cargo, 'weight'),
      },
      {
        label: 'CMB',
        value: eh.calcArrayPropertyTotal(outbound.cargo, 'cmb'),
      },
    ];

    const totalWeight =
      eh.getPayload(outbound.ATD, outbound.actualPaxLoad, outbound.cargo)
        .payload || 0;

    const isCrewBackToBack = crewChangeType === 'backToBack';

    return (
      <>
        {/*Aircraft*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={t('Aircraft/Crew')}
              items={aircraftSummaryItems}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock variant="contained">
              <FormTextField
                label={t('Aircraft_type')}
                name="outbound.aircraftType"
              />
              <FormTextField
                label={t('Aircraft_registration')}
                name="outbound.aircraftReg"
              />
              <FormTextField
                label={t('Aircraft_config')}
                name="outbound.aircraftConfig"
              />
            </FormBlock>
            <FormBlock variant="contained">
              <FormNumberField
                label={t('Pilots')}
                name={
                  isCrewBackToBack
                    ? 'inbound.crew.pilots'
                    : 'outbound.crew.pilots'
                }
                positiveInteger
              />
              <FormNumberField
                label={t('Cabin_Crew')}
                name={
                  isCrewBackToBack
                    ? 'inbound.crew.cabin'
                    : 'outbound.crew.cabin'
                }
                positiveInteger
              />
              <FormNumberField
                label={t('DHC')}
                name="outbound.crew.deadhead"
                positiveInteger
              />
              <FormSelect name="crewChangeType" items={eh.CREW_CHANGE_TYPES} />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Movement*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary title={t('Movement')} items={movementSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              <GridDateTimePicker xs={6} name="outbound.ETD" label="ETD" />
              <GridDateTimePicker xs={6} name="outbound.ATD" label="ATD" />
            </FormBlock>
            <FormBlock>
              <FormTextField
                size={3}
                label={t('DL_Time')}
                value={dlTimeValue}
              />
              {isDelayed && (
                <>
                  <Placeholder xs={5} />
                  <GridButton xs={3} color="secondary" label="Delayed" />
                </>
              )}
            </FormBlock>
            {t('Delay_codes')}
            <Delays values={values} setFieldValue={setFieldValue} />
          </AccordionDetails>
        </Accordion>
        {/*Delay checklist & services provided*/}
        {isDelayed && delayHours > 2 && (
          <ServicesProvided delay={delay} values={values} />
        )}
        {/*Locations*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={t('Locations')}
              items={locationsSummaryItems}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              <GridTextField
                xs={4}
                label={t('Check_in')}
                name="outbound.checkInCounters"
              />
              <GridTextField
                xs={4}
                label={t('Gate_no.')}
                name="outbound.gateNo"
              />
              <GridTextField
                xs={4}
                label={t('Parking_no.')}
                name="outbound.parkingBay"
              />
            </FormBlock>
            <FormBlock>
              <FormSelect
                size={4}
                name="outbound.parkingStand"
                items={eh.PARKING_STAND_TYPES}
              />
              <GridTextField
                xs={4}
                label={t('Rep. Gate')}
                name="outbound.repositionedGate"
              />
              <GridTextField
                xs={4}
                label={t('Rep. Parking')}
                name="outbound.repositionedParking"
              />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/* Pre-flight notes and tasks */}
        <Tasks
          tasksTitle={t('Pre_Flight_Tasks')}
          notesTitle={t('Pre_Flight_Notes')}
          notesName="outbound.preFlightNotes"
          tasksName="outbound.preFlightTasks"
          tasks={outbound.preFlightTasks}
          notes={outbound.preFlightNotes}
          setFieldValue={setFieldValue}
        />
        {/*Pre flight comments*/}
        {!!initialValues.outbound.preFlightComments && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classNames({
                [classes.warning]: outbound.preFlightComments,
              })}
            >
              Pre-flight Comments
            </AccordionSummary>
            <AccordionDetails className={classes.expansionDetails}>
              <TextField
                multiline
                maxRows="16"
                rows="4"
                name="outbound.preFlightComments"
                variant="outlined"
              />
            </AccordionDetails>
          </Accordion>
        )}
        {/*Booked Pax Load*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Booked_Pax_Load')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              <GridNumberField
                xs={2}
                label="F"
                name="outbound.bookedPaxLoad.first"
                allowedInputValue={positiveInteger}
              />
              <GridNumberField
                xs={2}
                label="C"
                name="outbound.bookedPaxLoad.business"
                allowedInputValue={positiveInteger}
              />
              <GridNumberField
                xs={2}
                label="Y"
                name="outbound.bookedPaxLoad.economy"
                allowedInputValue={positiveInteger}
              />
              <GridNumberField
                xs={2}
                label="INF"
                name="outbound.bookedPaxLoad.infant"
                allowedInputValue={positiveInteger}
              />
              <Placeholder xs={2} />
              <GridTextField
                xs={2}
                label={t('Total')}
                value={bookedTotalPaxLoad}
              />
            </FormBlock>
            <FormBlock>
              <Placeholder xs={6} />
              <GridNumberField
                xs={2}
                label={t('ADT')}
                name="outbound.bookedPaxLoad.adult"
                allowedInputValue={positiveInteger}
              />
              <GridNumberField
                xs={2}
                label={t('CHD')}
                name="outbound.bookedPaxLoad.child"
                allowedInputValue={positiveInteger}
              />
              <GridNumberField
                xs={2}
                label={t('INF')}
                name="outbound.bookedPaxLoad.infant"
                allowedInputValue={positiveInteger}
              />
            </FormBlock>
          </AccordionDetails>
        </Accordion>
        {/*Actual Pax Load*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={
                <div className={classes.spaceBetween}>
                  <span>{t('Actual_Payload')}</span>
                  <span>{totalWeight} kg</span>
                </div>
              }
              items={actualPaxLoadByClassSummaryItems}
            />
            <PanelSummary items={actualPaxLoadSummaryItems} />
            <PanelSummary items={totalBaggageSummaryItems} />
            <PanelSummary items={cargoSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <ActualPaxLoad values={values} setFieldValue={setFieldValue} />
          </AccordionDetails>
        </Accordion>
        {/*Transfer*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary
              title={t('Transfer_Transit')}
              items={transferSummaryItems}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <Transfers
              values={values}
              setFieldValue={setFieldValue}
              name="outbound.transfers"
            />
          </AccordionDetails>
        </Accordion>
        {/*Onwards*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PanelSummary title={t('Onwards')} items={onwardsSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <Transfers
              values={values}
              setFieldValue={setFieldValue}
              name="outbound.onwards"
            />
          </AccordionDetails>
        </Accordion>
        {/*Special Handling*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Special_Handling')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <TextField
              multiline
              rows="4"
              name="outbound.specialHandling"
              variant="outlined"
            />
          </AccordionDetails>
        </Accordion>
        {/*Cargo*/}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={classNames({
              [classes.warning]:
                outbound.cargo.length && !outbound.cargoLoadPlanSentAt,
            })}
          >
            <PanelSummary title={t('Cargo/Mail')} items={cargoSummaryItems} />
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <FormBlock>
              {outbound.cargo.map((cargo, i) => (
                <Accordion
                  expanded={expandedCargoItem === i}
                  key={`outbound.cargo[${i}]`}
                >
                  <AccordionSummary
                    className={classNames(classes.innerExpansionSummary, {
                      [classes.warning]: outbound.cargo[i].comments,
                    })}
                    expandIcon={
                      <ExpandMoreIcon
                        onClick={this.handleExpandedCargoItem.bind(null, i)}
                      />
                    }
                  >
                    <FormBlock>
                      <GridTextField
                        xs={5}
                        label="AWB No."
                        name={`outbound.cargo[${i}].awbNumber`}
                      />
                      <GridNumberField
                        xs={2}
                        label={t('PC')}
                        name={`outbound.cargo[${i}].packages`}
                        allowedInputValue={positiveInteger}
                      />
                      <GridNumberField
                        xs={2}
                        label={t('WT')}
                        name={`outbound.cargo[${i}].weight`}
                        allowedInputValue={positiveNumber}
                      />
                      <GridNumberField
                        xs={2}
                        label={t('CMB')}
                        name={`outbound.cargo[${i}].cmb`}
                        allowedInputValue={positiveNumber}
                      />
                    </FormBlock>
                  </AccordionSummary>
                  <AccordionDetails className={classes.expansionDetails}>
                    <TextField
                      multiline
                      fullWidth
                      label={t('Notes')}
                      rows="4"
                      maxRows="5"
                      variant="outlined"
                      name={`outbound.cargo[${i}].comments`}
                    />
                    <FormBlock>
                      <Placeholder xs={9} />
                      <GridIconFab
                        className={classes.withTopSpacer}
                        color="secondary"
                        xs={3}
                        icon="delete"
                        onClick={() =>
                          onDeleteConfirmationDialogOpen(
                            this.handleDeleteCargoClick.bind(null, i)
                          )
                        }
                      />
                    </FormBlock>
                  </AccordionDetails>
                </Accordion>
              ))}
            </FormBlock>
            <FormBlock>
              <Placeholder xs={9} />
              <GridButton
                xs={3}
                variant="contained"
                color="primary"
                label={t('ADD')}
                onClick={this.handleAddCargoClick}
              />
            </FormBlock>
            {outbound.cargo.length > 0 && (
              <InlineDateTimePicker
                label="Load plan sent at"
                name={`outbound.cargoLoadPlanSentAt`}
              />
            )}
          </AccordionDetails>
        </Accordion>
        {/*Ramp*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Ramp')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <Ramp
              values={values}
              setFieldValue={setFieldValue}
              services={rampServices}
            />
          </AccordionDetails>
        </Accordion>
        {/*Offload*/}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Offload')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <Offload values={values} setFieldValue={setFieldValue} />
          </AccordionDetails>
        </Accordion>
        {/*Airport Taxes*/}
        {false && (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Airport Taxes
            </AccordionSummary>
            <AccordionDetails className={classes.expansionDetails}>
              <InlineNumberField
                label="Joining"
                name="outbound.joining"
                allowedInputValue={positiveInteger}
              />
              <InlineNumberField
                label="Transfers <24h"
                name="outbound.transfersLess12h"
                allowedInputValue={positiveInteger}
              />
              <InlineNumberField
                label="Transfers >24h"
                name="outbound.transfersMore24h"
                allowedInputValue={positiveInteger}
              />
              <InlineNumberField
                label="Transfers >24h (technical delay)"
                name="outbound.transfersMore24hTechDelay"
                allowedInputValue={positiveInteger}
              />
              <InlineNumberField
                label="Transit with the same flight number"
                name="outbound.transitSameFlight"
                allowedInputValue={positiveInteger}
              />
            </AccordionDetails>
          </Accordion>
        )}
        {/* Excess Baggage / Ancillary Services */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Excess_Baggage_/_Ancillary_Services')}
          </AccordionSummary>
          <AccordionDetails className={classes.expansionDetails}>
            <InlineNumberField
              label={t('Total_MCO/EMD_issued')}
              name="outbound.excessBaggage.totalMcoEmd"
              allowedInputValue={positiveInteger}
            />
            {eh.isUralAirlines(values) && (
              <>
                {t('Excess_Baggage')}
                <InlineNumberField
                  label={t('Total_number_of_Promo_fare_pax_booked')}
                  name="outbound.excessBaggage.promoFarePaxNo"
                  allowedInputValue={positiveInteger}
                />
                <InlineNumberField
                  label={t('Additional_paid_baggage_quantity_sold')}
                  name="outbound.excessBaggage.additionalPaidBaggage"
                  allowedInputValue={positiveInteger}
                />
                <InlineNumberField
                  label={t('Overweight/oversize_baggage_quantity_sold')}
                  name="outbound.excessBaggage.overweightBaggage"
                  allowedInputValue={positiveInteger}
                />
                <InlineNumberField
                  label={t('Add/Overweight/Oversize_(Total_money_collected)')}
                  name="outbound.excessBaggage.baggageExcess"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Handbag_(Total_money_collected)')}
                  name="outbound.excessBaggage.handLuggageExcess"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Promo_fare_excess_baggage_(Total_money_collected)')}
                  name="outbound.excessBaggage.promoExcess"
                  allowedInputValue={positiveNumber}
                />
                {t('Ancillary_services')}
                <InlineNumberField
                  label={t('Pets_(Total_money_collected)')}
                  name="outbound.auxServices.pets"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Unaccompanied_Minors_(Total_money_collected)')}
                  name="outbound.auxServices.unaccompaniedMinors"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Commercial_Mail_(Total_money_collected)')}
                  name="outbound.auxServices.commercialMail"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Late_Check_In_Pax_(Total_money_collected)')}
                  name="outbound.auxServices.lateCheckInPax"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Seat_Selection_(Total_money_collected)')}
                  name="outbound.auxServices.seatSelection"
                  allowedInputValue={positiveNumber}
                />
                <InlineNumberField
                  label={t('Upgrade_(Total_money_collected)')}
                  name="outbound.auxServices.upgrade"
                  allowedInputValue={positiveNumber}
                />
              </>
            )}
          </AccordionDetails>
        </Accordion>
        {/*Notes (visible to airlines)*/}
        {eh.isUralAirlines(values) && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classNames({
                [classes.warning]: outbound.notesForAirline,
              })}
            >
              {t('Notes (for Handling report)')}
            </AccordionSummary>
            <AccordionDetails className={classes.expansionDetails}>
              <TextField
                multiline
                maxRows="16"
                rows="4"
                name="outbound.notesForAirline"
                variant="outlined"
              />
            </AccordionDetails>
          </Accordion>
        )}
        {/*Post flight comments (not visible to airlines)*/}
        <Tasks
          tasksTitle={t('Post-flight tasks')}
          notesTitle={t('Post-flight notes')}
          notesName="outbound.postFlightNotes"
          tasksName="outbound.postFlightTasks"
          tasks={outbound.postFlightTasks}
          notes={outbound.postFlightNotes}
          setFieldValue={setFieldValue}
        />
        {/*Post flight comments (not visible to airlines)*/}
        {!!initialValues.outbound.postFlightComments && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={classNames({
                [classes.warning]: outbound.postFlightComments,
              })}
            >
              Post-flight Internal Notes
            </AccordionSummary>
            <AccordionDetails className={classes.expansionDetails}>
              <TextField
                multiline
                maxRows="16"
                rows="4"
                name="outbound.postFlightComments"
                variant="outlined"
              />
            </AccordionDetails>
          </Accordion>
        )}
      </>
    );
  }
}

export default withTranslation()(
  withStyles(styles)(withDeletePopup(EventOutboundForm))
);
